import type { ReactElement } from 'react';

import type { RedactionState } from '@harness/stream-core';

/**
 * Announced to assistive technology the moment it renders, because a reader
 * using a screen reader deserves to know the text changed under them exactly
 * as much as a sighted reader does. States what happened in plain terms,
 * lists the categories, and reports how much was removed. A bare clear and a
 * safety retraction read differently because they mean different things.
 */
export function RedactionNotice({ redaction }: { redaction: RedactionState }): ReactElement {
  return (
    <div className="notice notice--signal redaction" role="status" aria-live="polite">
      <span className="notice__title">
        {redaction.bare ? 'Message cleared' : 'Content replaced'}
      </span>
      {redaction.bare ? (
        <p>
          The server retracted this message without a stated reason.{' '}
          <span className="mono">{redaction.previousLength}</span> characters were removed.
        </p>
      ) : (
        <p>
          The text was withheld by a content check and replaced.
          {redaction.categories.length > 0 && (
            <>
              {' '}
              Categories:{' '}
              {redaction.categories.map((category, index) => (
                <span key={category}>
                  {index > 0 && ', '}
                  <span className="mono">{category}</span>
                </span>
              ))}
              .
            </>
          )}{' '}
          <span className="mono">{redaction.previousLength}</span> characters were removed.
        </p>
      )}
    </div>
  );
}
